import {gql} from 'graphql-request';
import {useMutation} from '@tanstack/react-query';
import userStateGraphQLClient from '../services/UserStateApi/graphqlClient';

const useUpdateOnboarding = () =>
  useMutation(async userInput =>
    userStateGraphQLClient.request(
      gql`
        mutation UpsertUser($userInput: UserInput!) {
          upsertUser(user: $userInput) {
            user {
              onboarding {
                welcomeQuestion
                hasExistingRegistries
                otherRegistriesQuestion
              }
            }
            success
            message
          }
        }
      `,
      {
        userInput,
      },
    ),
  );

export default useUpdateOnboarding;
